export const PROGRESS_BAR_COLORS = {
  VALUE_100: '#2dce89',
  VALUE_75: '#fee101',
  VALUE_50: '#ffad00',
  VALUE_25: '#f5365c'
};

export const formatTimeToDHM = (minutes) => {
  if (minutes === 0) {
    return '00m';
  }

  const isNegative = minutes < 0;
  const absMinutes = Math.abs(minutes);
  const days = Math.floor(absMinutes / (60 * 24));
  const hours = Math.floor((absMinutes % (60 * 24)) / 60);
  const mins = absMinutes % 60;

  let timeString = isNegative ? '-' : '';
  if (days > 0) {
    timeString += `${String(days)}d `;
  }
  if (hours > 0 || days > 0) {
    timeString += `${String(hours).padStart(2, '0')}h `;
  }
  if (mins > 0 || hours > 0 || days > 0) {
    timeString += `${String(mins).padStart(2, '0')}m`;
  }
  return timeString.trim();
};
